<template>
  <div v-if="$userInfo.isSystemAdministrator">
    <app-detail-header :show-toggle="true"
      :show-new="false"
      :show-print="false"
      :show-delete="false"
      :show-save="false"
      :show-lock="false"
      :show-cancel="showCancel"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <system-modules-side-menu />
      </div>
      <div class="column">
        <router-view ref="currentChild" />
      </div>
    </div>
  </div>
  <div v-else
    class="is-flex is-justify-content-center pt-5">
    <div class="notification is-danger is-flex is-justify-content-center is-size-4"
      style="width: 50%">You do not have permissions on this page</div>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import { AppHeaderButtonTypes } from '@/enums'
import SystemModulesSideMenu from './SystemModuleSideMenu.vue'
import SuperadminSystemModuleRoutes from './route-types'

export default {
  name: 'SystemModuleView',
  components: {
    AppDetailHeader,
    SystemModulesSideMenu
  },
  data() {
    return {
      showAccessibleItems: true
    }
  },
  computed: {
    showCancel() {
      return this.$route.name !== SuperadminSystemModuleRoutes.SystemModulesDetail.name
    }
  },
  methods: {
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          break
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          break
        case AppHeaderButtonTypes.Save:
          break
        case AppHeaderButtonTypes.Cancel:
          this.cancel()
          break
      }
    },
    cancel() {
      this.$router.push({ name: SuperadminSystemModuleRoutes.SystemModuleView.name })
    }
  }
}
</script>

<style scoped>
</style>
